module.exports = __webpack_public_path__ + "img/shopx3.ecff1efb.png";